import {NgModule} from '@angular/core';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzNotificationModule} from 'ng-zorro-antd/notification';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzSkeletonModule} from 'ng-zorro-antd/skeleton';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NzAvatarModule} from 'ng-zorro-antd/avatar';

const ZORRO_MODULES: any[] = [
  NzAvatarModule,
  NzInputModule,
  NzButtonModule,
  NzSelectModule,
  NzIconModule,
  NzNotificationModule,
  NzFormModule,
  NzSpinModule,
  NzSkeletonModule,
  NzCardModule,
  NzToolTipModule
];

@NgModule({
  imports: [...ZORRO_MODULES],
  exports: [...ZORRO_MODULES]
})
export class ZorroModule {
}
